import styles from './style';

import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';

import Product from '../../../../listingPage/SearchResult/productList/product';

export default withNamespaces('searchPage')(withStyles(styles)(Product));
